/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Member Contact Phone Schema
 * @export
 * @interface MemberContactPhone
 */
export interface MemberContactPhone {
    /**
     * Member ID
     * @type {string}
     * @memberof MemberContactPhone
     */
    memberId: string;
    /**
     * Order
     * @type {number}
     * @memberof MemberContactPhone
     */
    order: number;
    /**
     * Phone
     * @type {string}
     * @memberof MemberContactPhone
     */
    phone: string;
    /**
     * Created Date
     * @type {Date}
     * @memberof MemberContactPhone
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MemberContactPhone
     */
    updatedDate: Date;
}

/**
 * Check if a given object implements the MemberContactPhone interface.
 */
export function instanceOfMemberContactPhone(value: object): value is MemberContactPhone {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MemberContactPhoneFromJSON(json: any): MemberContactPhone {
    return MemberContactPhoneFromJSONTyped(json, false);
}

export function MemberContactPhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberContactPhone {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': json['member_id'],
        'order': json['order'],
        'phone': json['phone'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MemberContactPhoneToJSON(value?: MemberContactPhone | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'member_id': value['memberId'],
        'order': value['order'],
        'phone': value['phone'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

